<img src="../../../assets/SIDeX-Icon.png" class="header-img" alt="">
@if (!showResubmission) {
  <div>
    <div class="action-section">
      <div class="flex-row">
        <div id="new-standard-order-card" class="flex-1 tool-card" (click)="makeStandardOrder()">
          <div class="tool-card-header" [style.background-color]="'#43a9be'">
            <img src="../../../assets/order.svg" alt="" class="main-image">
          </div>
          <div class="tool-card-body">
            <h3 class="tool-card-label">Standard Order</h3>
            <p>For standard deliveries of parts to Siemens Healthineers, utilize this option to upload all necessary quality documentation (i.e. FAIR, i-Diamond report, Certificate of Conformance, etc.) associated with a shipment. </p>
          </div>
        </div>
        <div id="new-just-documents-order-card" class="flex-1 tool-card" (click)="makeJustDocumentsOrder()">
          <div class="tool-card-header" [style.background-color]="'#ff8800'">
            <img src="../../../assets/non-standard-order.svg" alt="" class="main-image">
          </div>
          <div class="tool-card-body">
            <h3 class="tool-card-label">Non-Standard Order</h3>
            <p>Utilize this option for non-quality related documentation (i.e. a Request for Quotation) which is independent of standard shipments and requested by Siemens Healthineers. </p>
          </div>
        </div>
        @if (submittedOrders.length) {
          <div class="flex-1 tool-card" (click)="toggleSubmittedOrders()">
            <div class="tool-card-header" [style.background-color]="'#a6afb1'">
              <img src="../../../assets/resubmission.svg" alt="" class="main-image">
            </div>
            <div class="tool-card-body">
              <h3 class="tool-card-label"> Order Resubmission</h3>
              <p>In the event that a previous submission was missing required quality documentation, information within the previously submitted documentation was incomplete, and/or a resubmission was requested by Siemens Healthineers, utilize this option to provide the appropriate required documentation.</p>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
}
@if (showResubmission) {
  <div>
    <h3>Filter by Order ID:</h3> <input (input)="filterSubmittedOrders()" [(ngModel)]="filterString"/>
    <h3>Select Previous Order To Resubmit</h3>
    <div class="orders-section">
      <div class="flex-row">
        <h4 class="flex-1">Date</h4>
        <h4 class="flex-1">Order Name</h4>
        <h4 class="flex-1">SMN</h4>
        <h4 class="flex-1">Flanders Order ID</h4>
        <h4 class="flex-1">Swords Order ID</h4>
      </div>
      @for (order of submittedOrders | paginate: { itemsPerPage: 10, currentPage: page }; track order; let i = $index) {
        <div class="order-item" (click)="makeResubmissionOrder(order)" [class.order-item-fade]="i % 2 === 0">
          <div class="flex-row">
            <div class="flex-1">
              {{order.submissionDate.toLocaleDateString()}}
            </div>
            <div class="flex-1 order-title">
              {{ order.name }}
            </div>
            <div class="flex-1 item-title">
              {{ order.SMN }}
            </div>
            <div class="flex-1 item-title">
              {{ order.FlandersID }}
            </div>
            <div class="flex-1 item-title">
              {{ order.SwordsID }}
            </div>
          </div>
        </div>
      }
      <pagination-controls (pageChange)="page = $event"></pagination-controls>
    </div>
    <div style="display: flex; justify-content: flex-end; width: available">
      <div class="flex-1 action-button cancel-button" style="max-width: 200px; margin-top: 0" (click)="toggleSubmittedOrders()"> CANCEL </div>
    </div>
  </div>
}

<h2>
  For any IT related questions about SIDeX please email:
</h2>

<h3>
  SIDEXTechnicalSupport.dl&#64;siemens-healthineers.com
</h3>

